import { useLocation } from "react-router-dom"
import "./VentaHabitacion.css"
import VentaHabitacionForm from "./VentaHabitacionForm"
import useRentaCase from "./cases/renta/useRentaCase"
import useReservaCase from "./cases/reserva/useReservaCase"
import useVentaEnLineaCase from "./cases/venta-en-linea/useVentaEnLineaCase"

export type { DefaultValuesType } from "./VentaHabitacion.types"

const VentaRenta = () => <VentaHabitacionForm caso={useRentaCase()} />

const VentaReserva = () => <VentaHabitacionForm caso={useReservaCase()} />

const VentaEnLinea = () => <VentaHabitacionForm caso={useVentaEnLineaCase()} />

// El caso de venta se define por el state con el que se navega a la pantalla:
// - ventaEnLinea: check in de una habitación en venta en línea (la renta ya existe)
// - reservaSeleccionada: check in de una reserva
// - sin state: venta de mostrador
const VentaHabitacion = () => {
    const location = useLocation()

    if (location?.state?.ventaEnLinea) {
        return <VentaEnLinea />
    }
    if (location?.state?.reservaSeleccionada) {
        return <VentaReserva />
    }
    return <VentaRenta />
}

export default VentaHabitacion
